export enum SearchModeEnum {
  ONLY_LOADED_MESSAGES = "Loaded Messages Only",
  ALL_HISTORY = "All Messages History"
}
